const DETAIL_SLUG_DELIMITER = '--';
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const getSingleSegmentAfterParent = (
  pathname: string,
  parentPathname: string,
): string | null => {
  const normalizedPathname =
    pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const prefix = `${parentPathname}/`;

  if (!normalizedPathname.startsWith(prefix)) return null;

  const segment = normalizedPathname.slice(prefix.length);
  if (!segment || segment.includes('/')) return null;

  return segment;
};

const isRawDetailSegment = (segment: string | null): segment is string =>
  Boolean(segment && !segment.includes(DETAIL_SLUG_DELIMITER));

/**
 * KB native stack에는 canonical redirect 직전의 raw 상세 URL을 넣지 않는다.
 * 이후 Next redirect가 끝난 canonical URL만 stack에 push되게 하기 위한 guard.
 */
export const isCanonicalDetailRedirectSourcePathname = (
  pathname: string | null,
): boolean => {
  if (!pathname) return false;

  const uuidDetailParents = [
    '/policy',
    '/community/policyInfo',
    '/community/hometownNews',
  ];

  for (const parent of uuidDetailParents) {
    const segment = getSingleSegmentAfterParent(pathname, parent);
    if (isRawDetailSegment(segment) && UUID_PATTERN.test(segment)) return true;
  }

  const welloNewsSegment = getSingleSegmentAfterParent(
    pathname,
    '/community/welloNews',
  );
  if (isRawDetailSegment(welloNewsSegment) && /^\d+$/.test(welloNewsSegment)) {
    return true;
  }

  const emergencySegment = getSingleSegmentAfterParent(
    pathname,
    '/recommend-policy/situation/emergency',
  );
  if (isRawDetailSegment(emergencySegment) && /^\d+$/.test(emergencySegment)) {
    return true;
  }

  const giftSegment = getSingleSegmentAfterParent(pathname, '/donation/gifts');
  if (
    isRawDetailSegment(giftSegment) &&
    giftSegment !== 'search' &&
    /^[A-Za-z0-9][A-Za-z0-9_-]*$/.test(giftSegment)
  ) {
    return true;
  }

  return false;
};
